var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBulbFhsDetail = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    rx: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5783 34.849H23.1445C22.614 34.849 22.1812 34.4162 22.1812 33.8857V33.4536C22.1812 28.4355 17.001 27.0259 17.001 20.2821C17.001 14.0947 22.1811 11.001 27.3614 11.001C32.5417 11.001 37.7217 14.0947 37.7217 20.2821C37.7217 27.0259 32.5415 28.4355 32.5415 33.4536V33.8857C32.5415 34.4163 32.1088 34.849 31.5782 34.849H31.5783Z",
    fill: "#6C7DE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9598 38.3564C22.4745 38.3564 22.0809 37.963 22.0809 37.4775C22.0809 36.9921 22.4744 36.5986 22.9598 36.5986H31.0402C31.5255 36.5986 31.9191 36.9921 31.9191 37.4775C31.9191 37.963 31.5256 38.3564 31.0402 38.3564H22.9598Z",
    fill: "#56D8C0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8627 41.3154C24.3773 41.3154 23.9838 40.922 23.9838 40.4365C23.9838 39.9511 24.3772 39.5576 24.8627 39.5576H29.1374C29.6228 39.5576 30.0163 39.9511 30.0163 40.4365C30.0163 40.922 29.6228 41.3154 29.1374 41.3154H27.8789V41.6403C27.8789 42.1257 27.4855 42.5193 27 42.5193C26.5146 42.5193 26.1211 42.1258 26.1211 41.6403V41.3154H24.8627Z",
    fill: "#56D8C0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4395 24.7754H28.1973V34.9673H26.4395V24.7754Z",
    fill: "#56D8C0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3178 25.6356C28.5979 25.6356 29.6356 24.5979 29.6356 23.3178C29.6356 22.0377 28.5979 21 27.3178 21C26.0377 21 25 22.0377 25 23.3178C25 24.5979 26.0377 25.6356 27.3178 25.6356Z",
    fill: "#56D8C0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.1719 20.4826C43.6572 20.4826 44.0508 20.8761 44.0508 21.3615C44.0508 21.847 43.6573 22.2404 43.1719 22.2404H41.262C40.7767 22.2404 40.3831 21.847 40.3831 21.3615C40.3831 20.8761 40.7766 20.4826 41.262 20.4826H43.1719ZM10.8281 22.2404C10.3428 22.2404 9.94922 21.847 9.94922 21.3615C9.94922 20.8761 10.3427 20.4826 10.8281 20.4826H12.738C13.2233 20.4826 13.6169 20.8761 13.6169 21.3615C13.6169 21.847 13.2234 22.2404 12.738 22.2404H10.8281ZM12.3821 14.6806C11.963 14.4379 11.8201 13.9014 12.0628 13.4824C12.3055 13.0634 12.8419 12.9204 13.261 13.1632L14.9149 14.1181C15.334 14.3608 15.4769 14.8973 15.2342 15.3163C14.9915 15.7353 14.4551 15.8782 14.036 15.6356L12.3821 14.6806ZM13.2576 29.56C12.8385 29.8007 12.3036 29.6563 12.0628 29.2372C11.822 28.8182 11.9665 28.2833 12.3855 28.0425L14.0395 27.0876C14.4585 26.8467 14.9934 26.9912 15.2343 27.4103C15.475 27.8294 15.3306 28.3642 14.9115 28.605L13.2576 29.56ZM41.6178 28.0425C42.0369 28.2853 42.1798 28.8217 41.9371 29.2407C41.6944 29.6598 41.158 29.8027 40.7389 29.56L39.085 28.6051C38.666 28.3624 38.5231 27.8259 38.7657 27.4069C39.0085 26.9879 39.5449 26.8449 39.9639 27.0876L41.6178 28.0425ZM40.7424 13.1632C41.1614 12.9224 41.6963 13.0669 41.9371 13.486C42.1779 13.905 42.0334 14.4399 41.6144 14.6807L39.9604 15.6356C39.5414 15.8764 39.0065 15.732 38.7657 15.3129C38.5249 14.8938 38.6693 14.359 39.0884 14.1181L40.7424 13.1632Z",
    fill: "#6C7DE5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBulbFhsDetail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bulb_fhs_detail.b629e3fd6280f52debf0e923d7c6b910.svg";